import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
import Status from '../status';
import useMobile from '../hooks/use-mobile';
const status = {
  verified: {
    icon: 'success',
    status: 'Verified',
    helperText: 'Verified last'
  },
  'signed-up': {
    icon: 'person',
    status: 'Signed Up',
    helperText: 'Invited last'
  },
  'verification-in-progress': {
    icon: 'circle',
    status: 'Verification In Progress',
    helperText: 'Invited last'
  }
};
const StyledContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: ${Colors.white};
  border-radius: 4px;
  width: 100%;
`;
const StyledPair = styled.View`
  flex-direction: column;
`;
const StyledStatus = styled.View`
  align-self: center;
`;
const StyledText = styled(Text.BodySmall)`
  line-height: 21px;
`;

const formatDate = date => {
  const day = date.toLocaleDateString('en-US', {
    day: '2-digit'
  });
  const month = date.toLocaleDateString('en-US', {
    month: 'short'
  });
  const year = date.getFullYear();
  return `${month}. ${day}, ${year}`;
};

export default function Referrals(props) {
  const mobile = useMobile();
  const date = formatDate(props.date);
  const type = Object.keys(status).includes(props.status) ? props.status : Referrals.defaultProps.status;
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(StyledPair, null, /*#__PURE__*/React.createElement(Text.BodyBase, {
    weight: "medium",
    color: Colors.gray600
  }, props.children), mobile && /*#__PURE__*/React.createElement(StyledText, {
    weight: "regular",
    color: Colors.gray300
  }, status[type].helperText, ' ', date) || /*#__PURE__*/React.createElement(Text, {
    fontFamily: "LarsseitRegular",
    color: Colors.gray300,
    size: 13,
    lineHeight: 19.5
  }, status[type].helperText, ' ', date)), /*#__PURE__*/React.createElement(StyledStatus, null, type === 'verified' && /*#__PURE__*/React.createElement(Status, {
    type: status[type].icon
  }, status[type].status) || /*#__PURE__*/React.createElement(Status, {
    type: "neutral",
    icon: status[type].icon
  }, status[type].status)));
}
Referrals.defaultProps = {
  status: 'signed-up',
  date: new Date(),
  children: ''
};
Referrals.propTypes = {
  status: PropTypes.oneOf(Object.keys(status)),
  date: PropTypes.instanceOf(Date),
  children: PropTypes.node
};
//# sourceMappingURL=index.js.map